import debounce from 'lodash/debounce';

function isJustifiedByFixedElement(edge) {
  return Array.from(document.body.children).some(el => {
    const style = window.getComputedStyle(el);
    if (
      style.position !== 'fixed' ||
      style.display === 'none' ||
      style.visibility === 'hidden'
    ) {
      return false;
    }
    const rect = el.getBoundingClientRect();
    if (rect.height === 0) {
      return false;
    }
    return edge === 'top'
      ? rect.top <= 5
      : rect.bottom >= window.innerHeight - 5;
  });
}

function clearStaleEdgePadding(edge) {
  const cssProp = edge === 'top' ? 'paddingTop' : 'paddingBottom';
  const inlinePadding = parseFloat(document.body.style[cssProp]) || 0;
  if (inlinePadding > 0 && !isJustifiedByFixedElement(edge)) {
    document.body.style.removeProperty(
      edge === 'top' ? 'padding-top' : 'padding-bottom',
    );
  }
}

function clearStalePadding() {
  clearStaleEdgePadding('top');
  clearStaleEdgePadding('bottom');
}

// Google's AdSense anchor ad (and, on mobile, top-anchored ad formats)
// reserve space by setting an inline padding-top/padding-bottom on <body>,
// but Google's own script doesn't always clean that up when the ad is
// dismissed - a known AdSense quirk. Watch for it and clear it ourselves
// once nothing is actually pinned to that edge of the viewport to justify
// the reserved space.
export default function watchStaleBodyPadding() {
  const check = debounce(clearStalePadding, 300);
  const observer = new MutationObserver(check);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['style'],
    childList: true,
  });
  const interval = setInterval(clearStalePadding, 2000);
  return () => {
    observer.disconnect();
    clearInterval(interval);
  };
}
